import {
  Dispatch,
  SetStateAction,
  SyntheticEvent,
  useEffect,
  useState,
} from 'react';
import { observer } from 'mobx-react-lite';
import { Checkbox, Icon, Label, Step } from 'semantic-ui-react';
import { cardcolor3 } from '../../../app/common/form/errorMessageText';
import {
  TemplateSubTasks,
  WorkFlowSubTasks,
} from '../../../app/models/template';
import { useStore } from '../../../app/stores/store';
import TaskFormModal from './TaskFormModal';
import agent from './../../../app/api/agent';
import { toast } from 'react-toastify';
import { v4 as uuid } from 'uuid';
import { ThreeDotLoader } from '../../../app/layout/LoadingComponent';
import { columnType } from '../../../app/common/components/DynamicRowsComponent';
import { Task, activeOrderType, subTasks } from '../../../app/api/types';

interface Props {
  activityId: string;
  sortedListItems: activeOrderType;
  setSortedListItems: Dispatch<SetStateAction<activeOrderType>>;
  listTaskItems: Task[];
  setListTaskItems: Dispatch<SetStateAction<Task[]>>;
  activeIndexes: {
    task: number;
    subTask: number;
  };
  setActiveIndexes: Dispatch<
    SetStateAction<{
      task: number;
      subTask: number;
    }>
  >;
}

function TaskForm({
  activityId,
  sortedListItems,
  setSortedListItems,
  setActiveIndexes,
  listTaskItems,
  setListTaskItems,
}: Props) {
  const {
    mediaAssetStore,
    activityStore,
    ElementStore,
    RolesAndPermissionsIDStore,
    commonStore,
    userStore,
    metaDataStore,
    activityStore:{selectedActivity:activity},
    viewStore: {
      getActiveOrder,
      viewPageHistory,
      activeOrder,
      assignedUsers,
      allowStart,
    },
    viewStore
  } = useStore();
  const {
    collectActiveSubTas,
    getActiveSubtaskInd,
    setSelectedTask,
    getTotalCountsOfTask,
    Kanban_model_Mute_button,
  } = ElementStore;

  const [showSubtasksRow, setShowSubtasksRow] = useState(false);
  const [showTasksModal, setShowTasksModal] = useState(false);
  const [eleModalTitle, setEleModalTitle] = useState<any>([]);
  const [subTaskIdNo, setSubTaskIdNo] = useState('');
  const [taskTitleName, setTaskTitleName] = useState('');

  const [selectedSubTask, setSelectedSubtask] = useState<any>();
  const [taskId, setTaskId] = useState<string>();
  const [currSubTaskData, setCurrSubTaskData] = useState<any>();
  const [taskIndex, setTaskIndex] = useState(0);
  const [subTaskIndex, setSubTaskIndex] = useState(0);
  const [nfaiToast, setNfaiToast] = useState<string>('');

  useEffect(() => {
    Kanban_model_Mute_button(false);
    // eslint-disable-next-line
  }, [Kanban_model_Mute_button, showTasksModal]);

  useEffect(()=>{
  if(commonStore.NFAIReportCustomer){
    commonStore.NFAIodsModel = showTasksModal;
  }
  // eslint-disable-next-line
  },[showTasksModal])
  useEffect(() => {
    if (
      activeOrder.templateId &&
      mediaAssetStore.mediaAsset.editworkflow === 'edit'
    )
      getTotalCountsOfTask(activeOrder.templateId);
    // eslint-disable-next-line
  }, [activeOrder.templateId, mediaAssetStore.mediaAsset.editworkflow]);

  useEffect(() => {
    let tasks = [...activeOrder.tasks];
    setListTaskItems(tasks);
    setSortedListItems(activeOrder);
    // eslint-disable-next-line
  }, [activeOrder]);

  useEffect(() => {
    let index = 0;
    for (let i = 0; i < listTaskItems?.length; i++) {
      if (listTaskItems[i]?.isCurrentTask) {
        index = i;
        setActiveIndexes((p) => ({
          ...p,
          task: i,
        }));
      }
      for (let j = 0; j < listTaskItems?.[index]?.subTasks?.length; j++) {
        if (listTaskItems?.[index]?.subTasks?.[j]?.isCurrentSubtask) {
          setActiveIndexes((p) => ({
            ...p,
            subTask: i,
          }));
        }
      }
    }
    // eslint-disable-next-line
  }, [listTaskItems]);

  useEffect(() => {
    (async () => {
      if (mediaAssetStore.mediaAsset.editworkflow === 'close') {
        await getActiveOrder({ itemId: activityId });
        setShowSubtasksRow(false);
      }
      if (mediaAssetStore.mediaAsset.editworkflow === 'save') {
        setShowSubtasksRow(false);
      }
    })();
    // eslint-disable-next-line
  }, [mediaAssetStore.mediaAsset.editworkflow]);

  //to show subtask
  const showSubtask = (
    task: Task,
    taskTitle: string,
    taskId: string,
    index: number,
    isCurrTask: boolean,
  ) => {
    metaDataStore.updateSideComponentHeight =
      !metaDataStore.updateSideComponentHeight;
    collectActiveSubTas(
      task?.subTasks
        ?.filter(
          (data: TemplateSubTasks) =>
            data.isActive === true && data.isDeleted === false && isCurrTask,
        )
        .sort((a: any, b: any) => a.subtaskIndex - b.subtaskIndex),
    );
    setTaskTitleName(taskTitle);
    // setTaskData(sortedListItems);
    setTaskId(taskId);
    setTaskIndex(index);
    // setIsCurrTask(isCurrTask);
    setSelectedTask(task); //selected Task

    if (task.subTasks.length === 1) {
      if (task.subTasks[0].subTaskName === task.taskName) {
        tiggerSubtasksModal(
          task.taskName,
          task.subTasks[0].subTaskName,
          task.subTasks[0].subTaskId,
          task.subTasks[0],
          0,
        );
        setShowSubtasksRow(false);
      } else {
        setShowSubtasksRow(true);
      }
    } else {
      setShowSubtasksRow(true); //shows the row
    }
  };

  const editTaskToggleHandler = (index: number, subTask: any): void => {
    setShowSubtasksRow(true);
    setTaskIndex(index);
  };

  // useEffect(() => {
  //   if (
  //     userStore.user?.customerName === 'NFAIReport' &&
  //     taskTitleName === 'Restoration' &&
  //     ['NFHM Reel Analysis QC', 'NFHM Restoration QC', 'Restoration'].includes(
  //       selectedSubTask?.subTaskName,
  //     ) &&
  //     activeOrder.templateName !== 'Cutlist Workflow'
  //   ) {
  //     allowStartNFAI({ itemId: activityId }, selectedSubTask.subTaskName);
  //   }
  //   // eslint-disable-next-line
  // }, [selectedSubTask, activeOrder.templateName]);

  useEffect(() => {
    if (
      userStore.user?.customerName === 'NFAIReport' &&
      taskTitleName === 'Restoration' &&
      ['NFHM Reel Analysis QC', 'NFHM Restoration QC', 'Restoration'].includes(
        selectedSubTask?.subTaskName,
      ) &&
      activeOrder.templateName !== 'Cutlist Workflow'
    ) {
      setNfaiToast(allowStart);
    } else {
      setNfaiToast('');
    }
    // eslint-disable-next-line
  }, [allowStart, selectedSubTask, activeOrder.templateName]);

  const tiggerSubtasksModal = (
    taskName:string,
    subTaskName: string,
    subTaskId: string,
    subTaskData: subTasks,
    index: number,
  ) => {
    setSubTaskIndex(index);
    if (mediaAssetStore.mediaAsset.editworkflow !== 'edit') {
      const modalTitle: string = ' / ' + taskName + ' / ' + subTaskName;
      setEleModalTitle(modalTitle); //modal title

      getActiveSubtaskInd(index);
      setSelectedSubtask(subTaskData);

      setSubTaskIdNo(subTaskId);
      // setSubTaskName(subTaskName);
      if(commonStore.NFAIReportCustomer){
      viewStore.NFAIReportReelAnalysisReport = [];
      viewStore.parentMetadata({itemId : activity?.id});
    }
      setShowTasksModal(true);
      setCurrSubTaskData(subTaskData);
      mediaAssetStore.setClickedTaskName(subTaskName);
      mediaAssetStore.simpleModalOpen(true);
    }
  };

  const closeTaskFormModal = (e: boolean) => {
    setShowTasksModal(false);
  };

  /** -------------------------- set active task and subtask ---------------------------- */
  const updateToggleVal = (e: any, data: any, index: number) => {
    let isAllowed = true;
    let tasks = [...(sortedListItems?.tasks || [])];
    /** -------------------------- when task is completed ---------------------------- */
    if (tasks[index].status === 'completed') {
      toast.info('You cannot modify the completed task.');
      return;
    }

    for (let i = index; i < tasks.length; i++) {
      if (!isAllowed) break;

      for (let j = 0; j < tasks[i].subTasks?.length; j++) {
        if (!isAllowed) break;

        if (tasks[i]?.subTasks?.[j]?.subTaskstatus !== 0) {
          // if (!tasks[i].subTasks[j].parallelSubtaskId?.length) {
          //   isAllowed = false;
          // } else
          // if (
          //   tasks[i].subTasks[j].subTaskId ===
          //   tasks[index].subTasks[j].subTaskId
          // ) {
          // }

          isAllowed = false;
        }
      }
    }

    if (!isAllowed) {
      if (data.isCurrentTask) {
        toast.info('You cannot disable active task.');
        return;
      }
      toast.info('Former tasks cannot be altered.');
      return;
    }
    if (tasks[index]) {
      tasks[index].isActive = !data.isActive;

      for (let i = 0; i < tasks[index]?.subTasks.length; i++) {
        if (tasks[index].isActive) {
          tasks[index].subTasks[i].isActive = true;
        } else {
          tasks[index].subTasks[i].isActive = false;
        }
      }
    }
    setListTaskItems(tasks);
  };

  // for subtask
  const toggleOnSubTask = (subtask: WorkFlowSubTasks, index: number) => {
    // eslint-disable-next-line
    let tasks = [...(sortedListItems?.tasks || [])];
    if (tasks[taskIndex].status === 'completed') {
      toast.info('You cannot modify the completed task.');
      return;
    }
    if (tasks[taskIndex]?.subTasks?.[index]?.subTaskstatus === 2) {
      toast.info('You cannot modify the completed subtask.');
      return;
    }

    if (tasks[taskIndex]?.subTasks?.[index]?.subTaskstatus === 1) {
      toast.info('You cannot modify the current subtask.');
      return;
    }

    // tasks[taskIndex].subTasks[index].isActive = !tasks[taskIndex].subTasks[index].isActive;

    let allow = true;

    for (let i = taskIndex; i < tasks.length; i++) {
      if (!allow) break;

      let subtaskIndex = taskIndex === i ? index : 0;

      for (let j = subtaskIndex; j < tasks[i].subTasks.length; j++) {
        if (!allow) break;
        if (tasks[i]?.subTasks?.[j]?.subTaskstatus !== 0) {
          allow = false;

          // if (!tasks[i].subTasks[j].parallelSubtaskId?.length) {
          //   allow = false;
          // } else if (
          //   tasks[i].subTasks[j].subTaskId ===
          //   tasks[taskIndex].subTasks[index].subTaskId
          // ) {
          // }
        }
      }
    }

    if (allow && tasks[taskIndex].subTasks[index]) {
      tasks[taskIndex].subTasks[index].isActive =
        !tasks[taskIndex].subTasks[index].isActive;

      let isAnyoneSubtaskActive = false;

      for (let i = 0; i < tasks[taskIndex]?.subTasks.length; i++) {
        if (tasks[taskIndex].subTasks[i].isActive) {
          isAnyoneSubtaskActive = true;
        }
      }

      if (!isAnyoneSubtaskActive) {
        tasks[taskIndex].isActive = false;
      } else {
        tasks[taskIndex].isActive = true;
      }
    } else {
      toast.info('Sorry, you cannot modify this.');
      return;
    }
    setListTaskItems(tasks);
  };

  // const completeSubtask = async () => {
  //   const listTaskItemsDup: WorkFlowTask[] = Object.assign([], listTaskItems);
  //   let taskIndexTemp = taskIndex || 0;
  //   let subTaskIndexTemp = subTaskIndex || 0;
  //   let totalCompleteTaskCount = 0;

  //   mediaAssetStore.mediaAsset.subtaskCompleteDetails = {
  //     isLoading: true,
  //     id:
  //       listTaskItemsDup?.[taskIndexTemp]?.subTasks[subTaskIndexTemp]
  //         ?.subTaskId || '',
  //   };

  //   try {
  //     if (TrackingReportStore.CurrentSubtaskStatus.status) {
  //       // TrackingReportStore.statusChanger(
  //       //   id,
  //       //   TrackingReportStore.CurrentSubtaskStatus.value,
  //       // );
  //       TrackingReportStore.CurrentSubtaskStatus.status = '';
  //       TrackingReportStore.CurrentSubtaskStatus.value = 0;
  //       TrackingReportStore.currWorkflowModel = false;
  //       setShowTasksModal(true);
  //       setTimeout(() => {
  //         TrackingReportStore.currWorkflowModel = true;
  //       }, 1000);
  //       return;
  //     }
  //     let payload = {
  //       templateId: sortedListItems?.templateId || '',
  //       itemId: activityId,
  //       taskId: listTaskItemsDup[taskIndexTemp].taskId,
  //       subtaskId:
  //         listTaskItemsDup[taskIndexTemp].subTasks[subTaskIndexTemp].subTaskId,
  //     };
  //     let p1 = new Promise(async (resolve) => {
  //       await agent.TaskFormTaskServices.updateCompleteSubTask(payload);
  //       resolve('');
  //     });

  //     p1.then(async () => {
  //       let activeTasks = listTaskItemsDup?.filter((data) => data.isActive);
  //       let activeSubtasks = activeTasks[
  //         activeTasks.length - 1
  //       ]?.subTasks?.flatMap((data) => (data.isActive ? data : []));
  //       for (let i = 0; i < listTaskItemsDup.length; i++) {
  //         if (listTaskItemsDup[i].status === 'completed') {
  //           totalCompleteTaskCount += 1;
  //         }
  //       }
  //       if (
  //         listTaskItemsDup[taskIndexTemp]?.taskId ===
  //           activeTasks[activeTasks.length - 1]?.taskId &&
  //         listTaskItemsDup[taskIndexTemp]?.subTasks[subTaskIndex]?.subTaskId ===
  //           activeSubtasks[activeSubtasks.length - 1]?.subTaskId
  //       ) {
  //         await Promise.all([
  //           agent.workflowStatus.updateWorkflowStatus({
  //             id: activityId,
  //             status: 'NA',
  //             current_task: 'NA',
  //             current_subtask: 'NA',
  //             isReceiving: false,
  //           }),
  //           // agent.workflowStatus.updateWorkflowInActive({
  //           //   itemId: id,
  //           //   templateId: payload.templateId,
  //           //   isActive: false
  //           // }),
  //           agent.workflowStatus.updateProductionCountThroughWF({
  //             itemId: activityId,
  //             totalTaskCount: listTaskItemsDup.length,
  //             totalCompleteTaskCount,
  //             isOrderComplete: true,
  //           }),
  //         ]);
  //       } else if (
  //         listTaskItemsDup[taskIndex].subTasks.length - 1 ===
  //         subTaskIndexTemp
  //       ) {
  //         await agent.workflowStatus.updateProductionCountThroughWF({
  //           itemId: activityId,
  //           totalTaskCount: listTaskItemsDup.length,
  //           totalCompleteTaskCount,
  //           isOrderComplete: false,
  //         });
  //       }
  //       activityStore.updateSchedule = true;
  //     })
  //       .then(() => {
  //         activityStore.updateSchedule = false;
  //         // toast.success("Task completed sucessfully");
  //         setTimeout(async () => {
  //           if (selectedSubTask?.api?.length) {
  //             await ElementStore.postAPITemp(subTaskIdNo, activityId || '');
  //           }
  //           await getActiveOrder({ itemId: activityId });
  //           await getItemDetails({ itemId: activityId });
  //         }, 500);
  //       })
  //       .catch((error) => {
  //         mediaAssetStore.mediaAsset.subtaskCompleteDetails = {
  //           isLoading: false,
  //           id: '',
  //         };
  //         console.error(error);
  //       });
  //   } catch {
  //     mediaAssetStore.mediaAsset.subtaskCompleteDetails = {
  //       isLoading: false,
  //       id: '',
  //     };
  //   }
  // };

  const hideSubtask = (data: boolean) => {
    setShowSubtasksRow(data);
  };

  const actionerNameHandler = (actionerName: string) => {
    let tasks = [...listTaskItems];
    if (tasks?.[taskIndex]?.subTasks?.[subTaskIndex]) {
      tasks[taskIndex].subTasks[subTaskIndex].actionerName = actionerName;
      setListTaskItems(tasks);
    }
  };

  const workflowHistoryHandler = (
    elements: {
      id: any;
      description: string;
      values: string;
      type: string;
    }[],
    removedRow: any,
    addedRow: any,
    initialElementValue: any,
    headers: any,
  ) => {
    function returntaskStatus(number: number) {
      switch (number) {
        case 0:
          return 'Yet to start';
        case 1:
          return 'Start';
        case 2:
          return 'Complete';
        case 3:
          return 'Hold';
        case 4:
          return 'Resume';
        case 5:
          return 'Reject';
        case 6:
          return 'Rework';
        case 7:
          return 'Resolve';
        default:
          return '';
      }
    }
    let p1 = new Promise(async (resolve) => {
      elements?.forEach(async (element) => {
        let payload = {
          id: uuid(),
          itemId: activityId,
          taskId: listTaskItems[taskIndex].taskId,
          taskName: listTaskItems[taskIndex].taskName,
          subTaskName: selectedSubTask.subTaskName,
          subTaskId: selectedSubTask.subTaskId,
          elementName: element.description,
          elementValue: `${element.values}`,
          dateTime: new Date().toISOString(),
          status: returntaskStatus(selectedSubTask.status),
        };
        let name = '';
        if (element.values?.toString()?.split(',')?.[1]) {
          name = element.values?.toString()?.split(',')?.[1];
        } else {
          name = element.values?.toString()?.split(',')?.[0];
        }
        let status = '';
        if (element.type === 'AddFiles') {
          status = `uploaded file(s) under field "${element.description}" for`;
        } else if (element.type === 'AddPhotograph') {
          status = `uploaded photo(s) under field "${element.description}" for`;
        } else if (element.type === 'Users') {
          status = `updated field "${element.description}" to "${name}" for`;
        } else if (element.type === 'DynamicTable') {
          if (removedRow[element.id]) {
            removedRow[element.id]?.forEach((data: any) => {
              delete data?._uuid_;
              commonStore.updateHistoryAlonePOST(
                `${userStore.user?.displayName} removed record ${JSON.stringify(
                  data,
                )
                  .split('_')
                  ?.join(' ')} from table: ${
                  element.description
                } for ${activityStore.selectedActivity?.title}`,
                activityStore.selectedActivity?.id,
                undefined,
                false,
                true,
              );
            });
          }
          if (addedRow[element.id]) {
            addedRow[element.id]?.forEach((data: any) => {
              delete data?._uuid_;
              commonStore.updateHistoryAlonePOST(
                `${userStore.user?.displayName} added record ${JSON.stringify(
                  data,
                )
                  .split('_')
                  ?.join(' ')} to table: ${
                  element.description
                } for ${activityStore.selectedActivity?.title}`,
                activityStore.selectedActivity?.id,
                undefined,
                false,
                true,
              );
            });
          }
          const historyLogs: string[] = [];

initialElementValue?.[element.id]?.forEach((data: any) => {
  const stringData = element.values?.split('DynamicTable|')?.[1];
  let tempValue = stringData !== undefined ? JSON.parse(stringData) : [];

  tempValue?.forEach((alteredData: any, index: number) => {
    headers?.[element.id]?.forEach((column: columnType) => {
      if (
        column.optionName !== '_uuid_' &&
        data[`_uuid_`] === alteredData[`_uuid_`]
      ) {
        let flag = 0;
        if (typeof data[column.optionName] === 'object') {
          if (
            JSON.stringify(data[column.optionName]) !==
            JSON.stringify(alteredData[column.optionName])
          ) {
            flag = 1;
          }
        } else {
          if (data[column.optionName] !== alteredData[column.optionName]) {
            flag = 1;
          }
        }

        if (flag) {
          const alterHistory = `${userStore.user?.displayName} altered record in table: ${element?.description} from "${data[column?.optionName]}" to "${alteredData[column?.optionName]}" under ${column?.optionName
            .split('_')
            ?.join(' ')} in record (${index + 1}) for ${activityStore.selectedActivity?.title}`;

          historyLogs.push(alterHistory);
        }
      }
    });
  });
});

// 🚨 Send all changes as a single update (joined by newline or another separator)
if (historyLogs.length > 0) {
  const combinedHistory = historyLogs.join('\n');
  commonStore.updateHistoryAlonePOST(
    combinedHistory,
    activityStore.selectedActivity?.id,
    undefined,
    false,
    true
  );
}

        }else {
          status = `set "${element.description}" as "${name}" for`;
        }
        if (element.type !== 'DynamicTable') {
          commonStore.updateHistoryAlonePOST(
            `${userStore.user?.displayName} ${status} ${activityStore.selectedActivity?.title}`,
            activityStore.selectedActivity?.id,
            undefined,
            false,
            true,
          );
        }
        await agent.TaskFormTaskServices.updateComponentsValuesInHistory(
          payload,
        );
        await viewStore.parentMetadata({itemId: activityStore.selectedActivity?.id});
      });
      resolve('');
    });

    p1.then(() => {
      let timer = setTimeout(async () => {
        await viewPageHistory({
          itemId: activityStore.selectedActivity?.id,
          pageNo: 1,
          pageSize: 4,
        });
      }, 500);
      return () => clearTimeout(timer);
    });
  };

  const filterRolesHandler = (id: string) => {
    let result = RolesAndPermissionsIDStore.rolesIDs?.filter((data) => {
      return data.itemId === id;
    });
    if (result[0]) {
      return result[0]?.mode;
    } else {
      return 1;
    }
  };

  return (
    <>
      <Step.Group
        attached="bottom"
        className="workflow-task-overflow"
        style={{ width: '100%', overflowY: 'scroll' }}
      >
        {(mediaAssetStore.mediaAsset.editworkflow === 'save' ||
          mediaAssetStore.mediaAsset.editworkflow === 'cancel' ||
          mediaAssetStore.mediaAsset.editworkflow === 'close') &&
          listTaskItems !== undefined &&
          listTaskItems.map((data: Task, index: number) => {
            return (
              <>
                {data.taskName !== '' &&
                  data.isActive === true &&
                  filterRolesHandler(data.templateTaskId) !== 2 && (
                    <Step
                      key={data.taskId}
                      className={
                        !data.isCurrentTask ||
                        filterRolesHandler(data.templateTaskId) === 0
                          ? 'disable-task'
                          : ''
                      }
                      style={
                        data.taskName === taskTitleName ? cardcolor3 : null
                      }
                      onClick={() => {
                        filterRolesHandler(data.templateTaskId) === 1 &&
                          showSubtask(
                            data,
                            data.taskName,
                            data.taskId,
                            index,
                            false,
                          );
                      }}
                    >
                      <Step.Content>
                        <Step.Title>
                          <>
                            {!filterRolesHandler(data.templateTaskId) && (
                              <Icon
                                style={{
                                  bottom: '-0.5px',
                                  left: '1px',
                                  position: 'relative',
                                }}
                                name="lock"
                                color="grey"
                              />
                            )}
                            {data.status !== undefined &&
                              data.status !== null &&
                              data.status.toLowerCase() !== 'yet to start' && (
                                <>
                                  {
                                    data.status === '1' && (
                                      <Icon
                                        style={{
                                          bottom: '-0.5px',
                                          left: '1px',
                                          position: 'relative',
                                        }}
                                        name="dot circle outline"
                                        color="green"
                                      />
                                    ) //start
                                  }
                                  {
                                    (data.status.toLowerCase() === 'completed' ||
                                      data.status === '7') && (
                                      <Icon
                                        style={{
                                          bottom: '-0.5px',
                                          left: '1px',
                                          position: 'relative',
                                        }}
                                        name="check"
                                        color="green"
                                      />
                                    ) //complete
                                  }
                                  {
                                    data.status === '3' && (
                                      <Icon
                                        style={{
                                          bottom: '-0.5px',
                                          left: '1px',
                                          position: 'relative',
                                        }}
                                        name="pause circle outline"
                                        color="grey"
                                      />
                                    ) //hold
                                  }
                                  {
                                    data.status === '4' && (
                                      <Icon
                                        style={{
                                          bottom: '-0.5px',
                                          left: '1px',
                                          position: 'relative',
                                        }}
                                        name="play circle outline"
                                        color="yellow"
                                      />
                                    ) //Resume
                                  }
                                  {
                                    data.status === '5' && (
                                      <Icon
                                        style={{
                                          bottom: '-0.5px',
                                          left: '1px',
                                          position: 'relative',
                                        }}
                                        name="window close outline"
                                        color="red"
                                      />
                                    ) //Reject
                                  }
                                  {
                                    data.status === '6' && (
                                      <Icon
                                        style={{
                                          bottom: '-0.5px',
                                          left: '1px',
                                          position: 'relative',
                                        }}
                                        name="thumbs up outline"
                                        color="blue"
                                      />
                                    ) //Resolve
                                  }
                                </>
                              )}
                          </>
                          {data.taskName}
                        </Step.Title>
                      </Step.Content>
                    </Step>
                  )}
              </>
            );
          })}
        {/* show when edit workflow clicked */}
        {mediaAssetStore.mediaAsset.editworkflow === 'edit' &&
          listTaskItems.map((data: any, index: number) => {
            return (
              <Step
                key={data.taskId}
                // style={ taskTitleName === data.taskName ? thinGray : null }
              >
                <Step.Content>
                  <Step.Title
                    onClick={() => editTaskToggleHandler(index, data.subTasks)}
                  >
                    <Label corner="left" size="small">
                      <Checkbox
                        name={data.taskName}
                        toggle
                        checked={data.isActive ? true : false}
                        onClick={(e: SyntheticEvent) =>
                          updateToggleVal(e, data, index)
                        }
                      />
                    </Label>
                    {data.status !== undefined &&
                      data.status !== null &&
                      data.status !== 0 && (
                        <>
                          {
                            (data.status === 1 || data.status === 8) && (
                              <Icon
                                style={{
                                  bottom: '-0.5px',
                                  left: '1px',
                                  position: 'relative',
                                }}
                                name="dot circle outline"
                                color="green"
                              />
                            ) //start
                          }
                          {
                            data.status === 2 && (
                              <Icon
                                style={{
                                  bottom: '-0.5px',
                                  left: '1px',
                                  position: 'relative',
                                }}
                                name="check"
                                color="green"
                              />
                            ) //complete
                          }
                        </>
                      )}
                    {data.taskName}
                  </Step.Title>
                </Step.Content>
              </Step>
            );
          })}
      </Step.Group>

      {showSubtasksRow && (
        <Step.Group
          widths={6}
          style={{
            marginTop: '0',
            marginLeft: '0px',
            overflow: 'auto',
            // width: "100.2%",
          }}
          size="small"
        >
          {(mediaAssetStore.mediaAsset.editworkflow === 'save' ||
            mediaAssetStore.mediaAsset.editworkflow === 'cancel' ||
            mediaAssetStore.mediaAsset.editworkflow === 'close') &&
            // when task name and subtask name match, subtask should not be visible
            !(
              listTaskItems?.[taskIndex]?.subTasks.length === 1 &&
              listTaskItems?.[taskIndex]?.subTasks[0].subTaskName ===
                listTaskItems?.[taskIndex].taskName
            ) &&
            listTaskItems?.[taskIndex]?.subTasks?.map(
              (data: subTasks, index: number) => {
                return (
                  <>
                    {data.subTaskName !== '' &&
                      data.isActive === true &&
                      filterRolesHandler(data.templateSubtaskId) !== 2 && (
                        <Step
                          key={data.subTaskId}
                          style={
                            data.subTaskName === selectedSubTask?.subTaskName &&
                            filterRolesHandler(data.templateSubtaskId) === 0 &&
                            filterRolesHandler(
                              listTaskItems?.[taskIndex]?.templateTaskId,
                            ) === 0
                              ? cardcolor3
                              : null
                          }
                          onClick={() =>{
                            filterRolesHandler(data.templateSubtaskId) === 1 &&
                            tiggerSubtasksModal(
                              taskTitleName,
                              data.subTaskName,
                              data.subTaskId,
                              data,
                              index,
                            )}
                          }
                          className={
                            !data.isCurrentSubtask ||
                            filterRolesHandler(data.templateSubtaskId) === 0
                              ? 'disable-subtask'
                              : ''
                          }
                        >
                          {mediaAssetStore.mediaAsset.subtaskCompleteDetails
                            .isLoading &&
                          mediaAssetStore.mediaAsset.subtaskCompleteDetails
                            .id === data.subTaskId ? (
                            <div
                              style={{
                                width: 'max-content',
                                height: '20px',
                                position: 'relative',
                              }}
                            >
                              <ThreeDotLoader />
                            </div>
                          ) : (
                            <Step.Content>
                              <Step.Title
                                style={{
                                  textAlign: 'center',
                                }}
                              >
                                <>
                                  {filterRolesHandler(
                                    data.templateSubtaskId,
                                  ) === 0 && (
                                    <Icon
                                      style={{
                                        bottom: '-0.5px',
                                        left: '1px',
                                        position: 'relative',
                                      }}
                                      name="lock"
                                      color="grey"
                                    />
                                  )}
                                  {data.subTaskstatus !== undefined &&
                                    data.subTaskstatus !== null &&
                                    data.subTaskstatus !== 0 && (
                                      // data.isCurrentSubtask && (
                                      <>
                                        {
                                          (data.subTaskstatus === 1 ||
                                            data.subTaskstatus === 8) && (
                                            <Icon
                                              style={{
                                                bottom: '-0.5px',
                                                left: '1px',
                                                position: 'relative',
                                              }}
                                              name="dot circle outline"
                                              color="green"
                                            />
                                          ) //start
                                        }
                                        {
                                          (data.subTaskstatus === 2 ||
                                            data.subTaskstatus === 7) && (
                                            <Icon
                                              style={{
                                                bottom: '-0.5px',
                                                left: '1px',
                                                position: 'relative',
                                              }}
                                              name="check"
                                              color="green"
                                            />
                                          ) //complete
                                        }
                                        {
                                          data.subTaskstatus === 3 && (
                                            <Icon
                                              style={{
                                                bottom: '-0.5px',
                                                left: '1px',
                                                position: 'relative',
                                              }}
                                              name="pause circle outline"
                                              color="grey"
                                            />
                                          ) //hold
                                        }
                                        {
                                          data.subTaskstatus === 4 && (
                                            <Icon
                                              style={{
                                                bottom: '-0.5px',
                                                left: '1px',
                                                position: 'relative',
                                              }}
                                              name="play circle outline"
                                              color="yellow"
                                            />
                                          ) //Resume
                                        }
                                        {
                                          data.subTaskstatus === 5 && (
                                            <Icon
                                              style={{
                                                bottom: '-0.5px',
                                                left: '1px',
                                                position: 'relative',
                                              }}
                                              name="window close outline"
                                              color="red"
                                            />
                                          ) //Reject
                                        }
                                        {
                                          data.subTaskstatus === 6 && (
                                            <Icon
                                              style={{
                                                bottom: '-0.5px',
                                                left: '1px',
                                                position: 'relative',
                                              }}
                                              name="thumbs up outline"
                                              color="blue"
                                            />
                                          ) //Resolve
                                        }
                                      </>
                                    )}
                                </>
                                {data.subTaskName}
                              </Step.Title>
                            </Step.Content>
                          )}
                        </Step>
                      )}
                  </>
                );
              },
            )}
          {mediaAssetStore.mediaAsset.editworkflow === 'edit' &&
            listTaskItems?.[taskIndex]?.subTasks?.map(
              (subtask: any, index: number) => {
                return (
                  <Step
                    key={subtask.subTaskId}
                    onClick={() => toggleOnSubTask(subtask, index)}
                  >
                    <Step.Content>
                      <Step.Title>
                        <Label corner="left" size="small">
                          <Checkbox
                            name={subtask.subTaskName}
                            toggle
                            checked={subtask.isActive ? true : false}
                          />
                        </Label>
                        <Step.Description
                          onClick={() =>{
                            tiggerSubtasksModal(
                              taskTitleName,
                              subtask.subTaskName,
                              subtask.subTaskId,
                              subtask,
                              index,
                            )}
                          }
                          disabled={subtask.subtaskIndex !== 0}
                        >
                          {subtask.subTaskName}
                        </Step.Description>
                      </Step.Title>
                    </Step.Content>
                  </Step>
                );
              },
            )}
        </Step.Group>
      )}
      {!!selectedSubTask?.subTaskName?.length && showTasksModal && (
        <TaskFormModal
          taskname={taskTitleName}
          showTasksModal={showTasksModal}
          closeTaskFormModal={closeTaskFormModal}
          assignedUsers={assignedUsers}
          selectedSubTask={selectedSubTask}
          eleModalTitle={eleModalTitle}
          subTaskIdNo={subTaskIdNo}
          // filterRolesHandler={filterRolesHandler}
          taskData={sortedListItems}
          taskId={taskId}
          currSubTaskData={currSubTaskData}
          hideSubtask={hideSubtask}
          actionerNameHandler={actionerNameHandler}
          workflowHistoryHandler={workflowHistoryHandler}
          nfaiToast={nfaiToast}
        />
      )}
    </>
  );
}

export default observer(TaskForm);
